import { render, staticRenderFns } from "./flowerBaseList.vue?vue&type=template&id=d8220010&scoped=true&"
import script from "./flowerBaseList.vue?vue&type=script&lang=js&"
export * from "./flowerBaseList.vue?vue&type=script&lang=js&"
import style0 from "./flowerBaseList.vue?vue&type=style&index=0&id=d8220010&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8220010",
  null
  
)

export default component.exports